import { combineReducers } from 'redux';

import auth from './auth';
import chat from './chat';
import communities from './communities';
import currentCommunity from './currentCommunity';
import currentGroup from './currentGroup';
import events from './events';
import modal from './modal';
import statistics from './statistics';
import subscriptions from './subscriptions';

const rootReducer = combineReducers({
  communities,
  auth,
  modal,
  chat,
  currentCommunity,
  currentGroup,
  subscriptions,
  events,
  statistics,
});

export default rootReducer;

export type IRootState = ReturnType<typeof rootReducer>;
